import { useDispatch } from 'react-redux'
import type { ThunkDispatch } from 'redux-thunk'
import type { AnyAction } from 'redux'
import { reducers } from '../../store/reducers'

export type RootState = ReturnType<typeof reducers>

export type AppDispatch = ThunkDispatch<RootState, any, AnyAction>

export const useAppDispatch = () => useDispatch<AppDispatch>()
